import React, { useState, useRef, useEffect } from 'react'
import classNames from 'classnames'

import AutoComplete from '../AutoComplete/Autocomplete'
import Icon from '../../Icon2/Icon'
import AdvanceSearchPortal from '../AdvanceSearchPortal'

const SuggestQuery = (props) => {
  let [modalPosData, updateModalPosData] = useState({})
  const { queryObj, queryObjIndex, queryIndex, type, activeSuggestionIndex, withPortal = true } = props
  const isAutoCompleteOpen = `${queryObj.cursorY}-${queryObjIndex}-${queryIndex}-${type}` === activeSuggestionIndex
  const errorKey = `${type}Error`

  const suggestQueryRef = useRef(null)

  const prepareOpeningAutoComplete = (e) => {
    e.stopPropagation()
    if (!isAutoCompleteOpen) {
      const { target }: any = e
      console.log("🚀 ~ prepareOpeningAutoComplete ~ target:", target)
      const parentWithClass = target.closest('div.query-value')
      let { top, left } = parentWithClass.getBoundingClientRect()
      updateModalPosData({ clientY: top, clientX: left, width: suggestQueryRef.current.clientWidth })
      props.openAutoComplete(e, props.type)
    }
  }

  const openAutoCompleteOnEnter = () => {
    if (!isAutoCompleteOpen) {
      let { top, left } = suggestQueryRef.current.getBoundingClientRect()
      updateModalPosData({ clientY: top, clientX: left, width: suggestQueryRef.current.clientWidth })
      props.openAutoComplete({}, props.type)
    }
  }

  const fieldCursor = {
    key: 0,
    operator: 1,
    value: 2
  }
  const isCurrentQueryActive = props.cursorY === props.query.queryCursorY && !props.isDropdownOpen
  let isKeyActive = isCurrentQueryActive && fieldCursor.key === props.cursorX && type === 'key'
  let isOperatorActive = isCurrentQueryActive && fieldCursor.operator === props.cursorX && type === 'operator'
  let isValueActive = isCurrentQueryActive && fieldCursor.value === props.cursorX && type === 'value'

  if (props.query.queryType === 'localizedInLabel') {
    isKeyActive = false;
    isOperatorActive = isCurrentQueryActive && props.cursorX === 0 && type === 'operator'
    isValueActive = isCurrentQueryActive && props.cursorX === 1 && type === 'value'
  }

  const handleKeyBindings = (e) => {
    const { key } = e

    if (!props.isVisible) return

    if (key === 'Enter' && suggestQueryRef.current && (isKeyActive || isOperatorActive || isValueActive)) {
      openAutoCompleteOnEnter()
    }
    if (key === 'Escape' && isAutoCompleteOpen) {
      props.closeAutoComplete()
    }
  }

  useEffect(() => {
    document.addEventListener('keyup', handleKeyBindings, false)

    return () => {
      document.removeEventListener('keyup', handleKeyBindings, false)
    }
  }, [
    isCurrentQueryActive,
    isKeyActive,
    isOperatorActive,
    isValueActive,
    suggestQueryRef,
    isAutoCompleteOpen,
    openAutoCompleteOnEnter,
    props.isVisible
  ])

  return (
    <div
      data-test-id={props.testId}
      className={classNames(
        'query-value',
        type === 'operator' && props.query.queryType === 'localizedInLabel' && 'query-value__localizedBorder',
        props.type === 'key' && 'query-key-label',
        props.query[errorKey] && !props.query[type]?.length && 'query-value-error',
        props.placeholderClass,
        isKeyActive && 'query-value-active',
        isOperatorActive && 'query-value-active',
        isValueActive && 'query-value-active'

      )}
      ref={suggestQueryRef}
      onClick={prepareOpeningAutoComplete}>
      <div className="query-value-textTruncate">{props.value}</div>
      <Icon
        icon="CaretDownNew"
        version="v2"
        size="medium"
        className={classNames(isAutoCompleteOpen && 'dropdown-caret-up-new')}
      />

      {isAutoCompleteOpen && (
        <AdvanceSearchPortal withPortal={withPortal}>
          <AutoComplete
            isAutoCompleteOpen={isAutoCompleteOpen}
            closeAutoComplete={props.closeAutoComplete}
            selectedModule={props.selectedModule}
            fetchData={props.fetchData}
            currentQuery={props.query}
            queryType={props.query.queryType}
            type={type}
            queryArray={props.queryArray}
            currentQueryIndex={queryIndex}
            updateAdvancedQueryArray={props.updateAdvancedQueryArray}
            queryObject={queryObj}
            parentQueryObject={props.parentQueryObject}
            modalPosData={modalPosData}
            withPortal={withPortal}
            isTaxonomyPlanEnabled={props.isTaxonomyPlanEnabled}
          />
        </AdvanceSearchPortal>
      )}
    </div>
  )
}

export default SuggestQuery
